import React, { ReactElement } from 'react';
import { defineCustomElements as deckDeckGoHighlightElement } from '@deckdeckgo/highlight-code/dist/loader';
import styled from 'styled-components';
import { rem } from 'polished';
import { HTMLContent } from '../../components/Content';
import { Series } from './Series/Series';

deckDeckGoHighlightElement();

interface ArticleMobileTemplateProps {
  content?: any;
  series: any;
  children: ReactElement;
}

const StyledMobileArticle = styled.div`
  width: 100%;
  flex: 0 1 auto;
  .mobile-content-container {
    width: 100%;
    text-align: left;
    margin-bottom: ${rem(`48px`)};
    padding: ${rem(`16px`)};
    border-radius: ${rem(`12px`)};
    background-color: ${({ theme }) => theme.colors.blue_1_65};
    color: ${({ theme }) => theme.colors.gray_3};
    &:last-child {
      margin-bottom: 0;
    }
    > div {
      margin-bottom: 0;
    }
    ${({ theme }) => theme.breakpoints.phablet`
      padding: ${rem(`24px`)};
    `}
  }
`;

export const ArticleMobileTemplate = ({
  content,
  series,
  children,
}: ArticleMobileTemplateProps) => {
  return (
    <StyledMobileArticle>
      <div className="mobile-content-container">
        <Series items={series} />
        <HTMLContent>{content}</HTMLContent>
        <Series items={series} />
      </div>
      {children}
    </StyledMobileArticle>
  );
};
